import { connect } from 'react-redux';

import LoginPageComponent from '../components/LoginPage';

import {
  isAuthenticatedSelector,
} from '../reducers/auth';

import { login } from '../actions/auth';

const mapStateToProps = state => {
  return {
    isAuthenticated: isAuthenticatedSelector(state),
  };
};

const mapDispatchToProps = dispatch => {
  return {
    login: (username, password) => dispatch(login(username, password)),
  };
};

const LoginPage = connect(mapStateToProps, mapDispatchToProps)(LoginPageComponent);

export default LoginPage;